export type RenderStage =
  | "loading_data"
  | "waiting_for_tiles"
  | "tiles_loaded"
  | "map_render_ready"
  | "error_maps_auth"
  | "error_data";

/**
 * Returns true if the render process is actively waiting for Google Maps
 * satellite tiles and geometry to load into the viewport.
 * If data is still loading or an auth error occurred, returns false.
 */
export function isWaitingForMap(stage: RenderStage): boolean {
  return stage === "waiting_for_tiles";
}

/**
 * Returns a human-readable description of what the render page is doing
 * at the given stage.
 */
export function describeRenderStage(stage: RenderStage): string {
  switch (stage) {
    case "loading_data":
      return "Fetching job and property data from server";
    case "error_data":
      return "Failed to load job data from server";
    case "error_maps_auth":
      return "Google Maps API authentication failed";
    case "waiting_for_tiles":
      return "Waiting for Google Maps satellite tiles to finish rendering";
    case "tiles_loaded":
      return "Google Maps tiles loaded, waiting for render to settle";
    case "map_render_ready":
      return "Site map rendering complete and ready for capture";
  }
}
